import WidgetCommonContainer from "@/components/widgets/WidgetCommonContainer"
import { useAnalysisStats } from "@/queries/analysis"
import { WidgetWrapper } from "./WidgetWrapper"
import { router } from "expo-router"
import * as HomeEvents from "@/analytics/events/home"
export default function PropertiesWidget() {
  const { data: stats } = useAnalysisStats()

  const totalAnalysisCount = stats?.totalCount || 0

  const onPress = () => {
    HomeEvents.homepageWidgetClicked({
      nextScreen: "Properties",
      widgetTitle: "Properties",
      widgetType: "widget-properties",
      widgetValue: totalAnalysisCount.toString(),
    })
    router.push("/properties")
  }

  return (
    <WidgetWrapper
      title="Properties"
      category="properties"
      orientation="vertical"
      variant="default"
      onPress={onPress}
    >
      <WidgetCommonContainer
        headerCount={totalAnalysisCount.toString()}
        subTitle={"Properties total"}
        ctaText="View all"
      />
    </WidgetWrapper>
  )
}
